// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8vZqX","label":"styles_label__1Q-Yt"};